import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { object, string, ref, addMethod } from 'yup';

import UpdateUserPassword from 'buyside/graphql/mutations/UpdateUserPassword';

import ChangeUserLogIn from 'buyside/components/presentation/UserAccount/ChangeEmailPassword/changeUserLogIn';

// Yup's addMethod adds the function passed in to the schema class prototype.
// ES6 arrow function syntax automatically binds the context of the function,
// preventing the function to become a class instance.
// Yup's creator says, "Short answer, don't use an arrow function."
// https://github.com/jquense/yup/issues/395#issuecomment-446142969
// https://github.com/jquense/yup/issues/97#issuecomment-354872476
// - 23 Apr 2019 (TMA)
function equalTo(ref) {
  return this.test({
    name: 'equalTo',
    exclusive: false,
    message: 'Password must match',
    params: { reference: ref.path },
    test: function(value) {
      return value === this.resolve(ref);
    }
  });
}
addMethod(string, 'equalTo', equalTo);
const passwordValidationSchema = object().shape({
  currentPassword: string().required('Required'),
  password: string().required('Required'),
  passwordConfirmation: string()
    .equalTo(ref('password'))
    .required('Required')
});
const handleError = (e, setErrors) =>
  setErrors({ passwordConfirmation: e.graphQLErrors[0].message });

const ChangePasswordContainer = ({ currentUser }) => {
  const { currentPassword, password, passwordConfirmation } = currentUser;
  const formFields = [
    {
      type: 'password',
      name: 'currentPassword',
      label: 'Enter Your Old Password',
      value: currentPassword
    },
    { type: 'password', name: 'password', label: 'Enter Your New Password', value: password },
    {
      type: 'password',
      name: 'passwordConfirmation',
      label: 'Re-type Your New Password',
      value: passwordConfirmation
    }
  ];
  return (
    <Mutation mutation={UpdateUserPassword}>
      {mutate => {
        const updatePassword = args => mutate({ variables: args });
        return (
          <ChangeUserLogIn
            buttonText="Update password"
            changeText="Change Password"
            formFields={formFields}
            handleError={handleError}
            handleUpdate={updatePassword}
            label="Your password"
            successMessage="Password successfully updated"
            userInfo="........"
            validationSchema={passwordValidationSchema}
          />
        );
      }}
    </Mutation>
  );
};

export default ChangePasswordContainer;
